import "./ConventionSummary.scss";

export const conventionSummaryStyles = {
  section: "im-convention-summary__section",
  sectionHeader: "im-convention-summary__section__header",
  sectionHeaderMain: "im-convention-summary__section__header__main",
  sectionId: "im-convention-summary__section__id",
  subsection: "im-convention-summary__subsection",
  subsectionHeaderButton: "im-convention-summary__subsection-header-button",
  subsectionHighlighted: "im-convention-summary__subsection--highlighted",
  subsectionHorizontalSeparator:
    "im-convention-summary__subsection__horizontal-separator",
  subsectionVerticalSeparator:
    "im-convention-summary__subsection--vertical-separator",
  subsectionValue: "im-convention-summary__subsection__value",
  subsectionScheduleDay: "im-convention-summary__subsection__schedule__day",
  subsectionScheduleWeek: "im-convention-summary__subsection__schedule__week",
  subsectionElementFullWidth:
    "im-convention-summary__subsection-element-fullwidth",
  subsectionHeaderItems: "im-convention-summary__subsection-header-items",
};
